import { TTCUser } from '../interfaces/services/tid';
import { ApiStatus } from './enums';

export type Env = 'local' | 'development' | 'staging' | 'prod';

export const getEnv = (): Env => {
    switch (window.location.hostname) {
        case 'localhost':
            return 'local';
        case 'network-insights.dev.trimble-transportation.com':
            return 'development';
        case 'network-insights.stg.trimble-transportation.com':
            return 'staging';
        case 'network-insights.trimble-transportation.com':
            return 'prod';
        default:
            return 'development';
    }
};

export const getTTCDomain = (): string => {
    let baseUrl = '';
    switch (getEnv()) {
        case 'local':
        case 'development':
            baseUrl = 'cloud.dev.api.trimblecloud.com';
            break;
        case 'staging':
            baseUrl = 'cloud.stage.api.trimblecloud.com';
            break;
        case 'prod':
        default:
            baseUrl = 'cloud.api.trimble.com';
            break;
    }

    return baseUrl;
};

export const getTTCBaseUrl = (): string => {
    return `https://${getTTCDomain()}/transportation`;
};

export const hasNetworkInsightsRole = ({
    userLoginStatus,
    userDetails,
}: {
    userLoginStatus: ApiStatus;
    userDetails: TTCUser;
}): boolean => {
    const networkInsightsRoles = [
        'Network Insights Read Only',
        'network-insights-developer',
    ];

    if (userLoginStatus === ApiStatus.Success) {
        const userRole = userDetails.roles.find((role) => {
            return networkInsightsRoles.includes(role.name);
        });

        return userRole !== undefined;
    }

    return false;
};

export const hasNetworkRxRole = ({
    userLoginStatus,
    userDetails,
}: {
    userLoginStatus: ApiStatus;
    userDetails: TTCUser;
}): boolean => {
    const networkRxRoles = [
        'Network Rx Read Only',
        'network-rx-developer',
    ];

    if (userLoginStatus === ApiStatus.Success) {
        const userRole = userDetails.roles.find((role) => {
            return networkRxRoles.includes(role.name);
        });

        return userRole !== undefined;
    }

    return false;
};
